<template>
  <el-container>
    <el-header>
      <Header />
    </el-header>
    <el-main>
      <router-view />
    </el-main>
    <el-footer>
      <Footer />
    </el-footer>
    <el-backtop></el-backtop>
  </el-container>
</template>
<script>
import Header from "./Header";
import Footer from "./Footer";
export default {
  name: "Main",
  components: {
    Header,
    Footer
  }
};
</script>
<style lang="scss" scoped>
.el-header {
  padding: 0px;
  height: auto !important;
}
.el-main {
  padding: 0px;
  overflow: visible;
}
.el-footer {
  padding: 0px;
  height: auto !important;
}
</style>
